<!-- eslint-disable vue/valid-template-root -->
<template />
<script>
import {mapState, mapMutations, mapActions} from 'vuex';
import {deleteDocument} from '@/services/FirestoreService';

export default {
  name: 'DeleteSharedMap',
  props: {
    mapId: {
      type: String,
      default: undefined,
      required: false,
    },
  },
  emits: ['close'],
  computed: {
    ...mapState({
      'currentMapId': 'mapId',
    }),
  },
  mounted() {
    this.deleteMap();
  },
  methods: {
    ...mapActions(['addMessage']),
    ...mapMutations(['addRecentlyDeletedMapId']),
    deleteMap() {
      const message = {
        header: `Confirm Delete `,
        messageType: 'danger',
        body: `Are you sure you want to delete this map?`,
      };

      const actions = [{
        title: 'Delete',
        callback: () => {
          // If mapId is not provided as a prop, use the currentMapId from the store
          const deleteId = this.mapId ?? this.currentMapId;

          if (deleteId) {
            // Adds to recentlyDeleted store in maps
            this.addRecentlyDeletedMapId(deleteId);
            deleteDocument('sharedMaps', deleteId, [], true);
            this.$router.push({name: 'DashboardView'});
          }
        },
        class: 'primary'},
      ];

      this.addMessage({...message, actions});
      this.$emit('close');
    },
  },
};

</script>
